import React, { useState, useEffect } from 'react';

export default function ConnectionStatus() {
  const [backendStatus, setBackendStatus] = useState('checking'); // 'checking' | 'connected' | 'disconnected'

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const res = await fetch('/api/health', { signal: AbortSignal.timeout(5000) });
        setBackendStatus(res.ok ? 'connected' : 'disconnected');
      } catch {
        setBackendStatus('disconnected');
      }
    };
    checkHealth();
    const interval = setInterval(checkHealth, 30000);
    const onOnline = () => setTimeout(checkHealth, 1000);
    window.addEventListener('online', onOnline);
    return () => {
      clearInterval(interval);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return (
    <div
      title={backendStatus === 'connected' ? 'Backend connected' : backendStatus === 'checking' ? 'Checking connection...' : 'Backend disconnected'}
      style={{
        width: 7, height: 7, borderRadius: '50%', margin: '0 4px',
        background: backendStatus === 'connected' ? '#22c55e'
          : backendStatus === 'checking' ? '#facc15'
          : '#ef4444',
        boxShadow: backendStatus === 'connected' ? '0 0 6px rgba(34,197,94,0.5)' : 'none',
        transition: 'all 0.3s ease',
        flexShrink: 0,
      }}
    />
  );
}
